<div class="partners">
  <a *ngIf="partnerLink" [href]="partnerLink" target="_blanc"><img [src]="partnersUrl | safe" alt="partners" /></a>
  <img *ngIf="!partnerLink" [src]="partnersUrl | safe" alt="partners" />
</div>
